import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Alert, Spinner } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { loginAxios } from '../../../config/axios.config';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import './style.scss';

import StackedBarChartPro from './StackedBarChartPro';
import axios from "axios";
import {checkAndClearExpiredData} from '../../../../src/utils/Utils'

const OrderInward = () => {

    const [inwardData, setInwardData] = useState({});
    const [inwardChartData, setInwardChartData] = useState([]);
    const [QCChartData, setQCChartData] = useState([]);
    
    useEffect(async () => {

        if(sessionStorage.getItem('ORDER_INWARD_DATA') == null) {
            refetchInwardData.mutate();
        } else {
            setInwardData(JSON.parse(sessionStorage.getItem('ORDER_INWARD_DATA'))?.value);
        }

    }, []);

    setInterval(() => {
        if(checkAndClearExpiredData('ORDER_INWARD_DATA')) {
            refetchInwardData.mutate();
        }
    }, 3600000);

    const getInwardData = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/order-inward`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };
    
    const refetchInwardData = useMutation(getInwardData, {        
        onSettled(data, error) {
            if (data) {    
                
                                
                const now = new Date().getTime();
                const item = {
                    value: data?.data?.finalResponse,
                    timestamp: now
                };

                sessionStorage.setItem("ORDER_INWARD_DATA", JSON.stringify(item));
                setInwardData(data?.data?.finalResponse)
            }
        }
    }) 


    useEffect(() => {
        if(inwardData?.inward_resp?.length > 0) {
          let collectArr = inwardData?.inward_resp.map(item => {
            return {
              name: item.ship_date,
              data1: item.totalItems,
              data1Lable: 'Total Items'
            };
          });
          console.log(collectArr);
          setInwardChartData(collectArr);
        }
        if(inwardData?.qc_fail_rtv?.length > 0) {
            let collectArr = inwardData?.qc_fail_rtv.map(item => {                
              return {
                name: item.order_month,
                data1: item.total_items_post_cancellation,
                data1Lable: 'Total Items Post Cancellation'
              };
            });
            console.log(collectArr);
            setQCChartData(collectArr);
          }
      }, [inwardData]);


    return (<>
        
        <Head title="Order Inward Charts"></Head>
        
        <Content>            
            <BlockHead size="sm">
                <BlockBetween>
                    <BlockHeadContent>
                        <BlockTitle>Delays and QC Report</BlockTitle>
                        <ul className="list list-sm" id="list-note">
                        <li>This tab shows you a month-wise view of how many items we received from you on-time vs how many were delayed. Particular attention should be given to the number of items being received with delay >5 days. Such items have higher probability of client cancellations and hence lost revenue. A higher delay percentage will decrease your overall quality score on Aza’s platform and impact your revenue </li>
                        <li>The quality-check table shows the number of items from you that failed our quality check parameters. Frequent quality-check failures result in delays and cancellations </li>
                        <li>All graphs use the customer order-date as reference</li>                        
                      </ul>
                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>

            <Block>
                <Row>


                <Col md="12">
                        <Card className="card-stretch mt-2  p-3">
                        <h5 style={{textDecoration: 'underline'}}>Total Items Shipped to Aza</h5>
                        {refetchInwardData?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                            :
                            <div className="card-inner-group">
                                <StackedBarChartPro data={inwardData?.inward_delay} />                                
                            </div>
                            }
                        </Card>
                    </Col>


                    {/* <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Total Revenue</h5>
                            <div className="card-inner-group">                        
                                <PieChartPro mapData={totalRevenueData || []} total="13525" />
                            </div>
                        </Card>
                    </Col> */}


                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Delayed Items (With Breakup)</h5>

                            {refetchInwardData?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                            :
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Order Month</th>
                                        {/* <th scope="col">Total Items</th> */}
                                        {/* <th scope="col">Inwarded</th> */}
                                        <th scope="col">Total Received With Delay</th>
                                        <th scope="col">1-5 days Delay</th>
                                        <th scope="col">6-10 days Delay</th>
                                        <th scope="col">11-20 days Delay</th>                                        
                                        <th scope="col">Delay Above 20 Days</th>
                                        
                                        

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inwardData?.inward_delay?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data?.order_month}</td>    
                                                {/* <td>{data?.total_items_post_cancellation}</td>     */}
                                                {/* <td>{data?.inwarded}</td>     */}
                                                <td>{data?.inwarded_delayed}</td>    
                                                <td>{data["1_to_5days_delayed"]}</td>      
                                                <td>{data["6_to_10_days_delay"]}</td>                                                     
                                                <td>{data["11_to_20_days_delay"]}</td>      
                                                <td>{data["morethan20_days_delay"]}</td>                                            
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
}
                        </Card>
                    </Col>


                    <Col md="6">
                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Not Yet Received And Delayed</h5>
                            {refetchInwardData?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                            :
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">1-5 days Delay</th>
                                        <th scope="col">6-10 days Delay</th>
                                        <th scope="col">11-20 days Delay</th>
                                        <th scope="col">Delay Above 20 Days</th>
                                        
                                        
                                        

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inwardData?.pending_delay?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data["1_to_5_delayed"]}</td>        
                                                <td>{data["6_to_10_delayed"]}</td>  
                                                <td>{data["11_to_20_delayed"]}</td>      
                                                                                                                                           
                                                <td>{data["morethan20_days_delayed"]}</td>     
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            }
                        </Card>



                        <Card className="card-stretch mt-2 p-3">
                            <h5 style={{textDecoration: 'underline'}}>Quality Check Failure</h5>
                            {refetchInwardData?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                            :
                            <div className="card-inner-group">                        
                                            
                                <table className="table table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                        <th scope="col">Order Month</th>
                                        {/* <th scope="col">Total Items</th> */}
                                        <th scope="col">Received By Aza</th>
                                        <th scope="col">Quality Check Failed</th>
                                        <th scope="col">Sent Back For Alteration</th>
                                        {/* <th scope="col">QC Fail %</th> */}
                                        {/* <th scope="col">Inwarded</th>                                                                                                                         */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inwardData?.qc_fail_rtv?.map((data) => {          
                                        return (
                                            <tr>
                                                <td>{data?.order_month}</td>    
                                                {/* <td>{data?.total_items_post_cancellation}</td>     */}
                                                <td>{data["inwarded"]}</td>   
                                                <td>{data["qc_fail"]}</td>   
                                                <td>{data?.rtv_items}</td>                                                   
                                                {/* <td>{data?.inwarded}</td>                                                       */}
                                            </tr>
                                        );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        }
                        </Card>

                        
                    </Col>

         
                </Row>
            </Block>
        </Content>
        <ToastContainer />
    </>)
};

export default OrderInward;